"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

exports.__esModule = true;
exports["default"] = clearUndefinedProperties;

function clearUndefinedProperties(obj) {
  if (!obj) {
    return obj;
  }

  var newObj = {};
  Object.keys(obj).forEach(function (propertyName) {
    var value = obj[propertyName];

    if (value !== undefined) {
      newObj[propertyName] = value;
    }
  });
  return newObj;
}